import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

export default function Careers() {
    return (
        <section
            data-testid="careers-section"
            id="careers"
            className="relative py-24 md:py-32 bg-secondary/30"
        >
            <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
                <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                    Careers
                </div>
                <h2 className="font-display font-light text-4xl md:text-6xl tracking-tighter leading-tight">
                    We are always looking for{" "}
                    <span className="italic font-medium">builders</span>,
                    engineers, and problem solvers.
                </h2>
                <p className="mt-8 text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
                    If you love building thoughtful software, working alongside
                    senior engineers and shipping products that businesses
                    rely on — we&apos;d love to hear from you.
                </p>
                <div className="mt-10">
                    <Link to="/contact">
                        <Button
                            data-testid="careers-cta"
                            size="lg"
                            className="rounded-full px-7 h-12"
                        >
                            Get in touch
                            <ArrowRight className="ml-2 h-4 w-4" />
                        </Button>
                    </Link>
                </div>
            </div>
        </section>
    );
}
